<!--
 * @Description: 业务区域
 * @Author: yangsibo
 * @Date: 2022-05-12 08:59:49
 * @LastEditors: quwandong
 * @LastEditTime: 2022-12-28 09:04:58
 * @FilePath: \motion\src\views\Setting\BusinessArea\index.vue
-->
<template>
  <el-main class="business-area">
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <el-container>
        <el-aside class="left" width="27%">
          <LeftTree @getCurrentId="getCurrentId"></LeftTree>
        </el-aside>
        <el-main class="right">
          <RightTable :current="current" ref="RightTable"></RightTable>
        </el-main>
      </el-container>
    </div>
  </el-main>
</template>

<script>
import LeftTree from "./components/LeftTree";
import RightTable from "./components/RightTable";
export default {
  name: "BusinessArea",
  components: {
    LeftTree,
    RightTable,
  },
  data() {
    return {
      current: null,
    };
  },
  methods: {
    getCurrentId(data) {
      this.current = data;
      if (data.flag) {
        delete data.flag;
        this.$refs.RightTable.getPersonListbyZoneId(data.id);
      }
    },
  },
  created() {},
};
</script>
<style lang="scss" scoped>
.business-area {
  box-sizing: border-box;
  height: calc(100% - 70px);
  .main {
    max-height: calc(100% - 98px);
    ::v-deep .el-container {
      height: 100%;
      background: #fff;
      .left {
        border-right: 1px solid #efefef;
        padding: 15px 15px 15px 0;
      }
      .right {
        padding: 15px;
      }
    }
  }
}
</style>
